import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  TextField,
  CircularProgress,
  Grid,
  Button,
} from "@material-ui/core";
import {
  fetchConToken
} from "../../../../helpers/fetch";
import { useToggle } from "../../../../hooks/useToggle";
import { startAlerta } from "../../../../actions/ui/alertas";
import { ValidatorForm } from "react-material-ui-form-validator";
import { consultarRubrosProveedores, consultarTipoProveedores,desSeleccionarProveedor } from "../../../../actions/compras/ProveedoresAction";
import { types } from "../../../../types/types";
import { fetchProvincias } from "../../../../actions/cbos/provincias";
import { fetchLocalidades } from "../../../../actions/cbos/localidades";
import { BUSCADOR_CENTRAL } from "../../../../utils/constants";

export const BuscadorProveedor = ({ hasMedic }) => {
  const dispatch = useDispatch();

  const [isOpen, toggleOpen] = useToggle()
  const [options, setOptions] = useState([]);
  const [textoBuscado, setTextoBuscado] = useState("");
  const [proveedor, setProveedor] = useState(null);

  const cargando = isOpen && options.length === 0;
  let typingTimer = null

  useEffect(() => {
    dispatch(fetchProvincias())
    dispatch(fetchLocalidades())
    dispatch(consultarRubrosProveedores())
    dispatch(consultarTipoProveedores())
}, [dispatch])

  useEffect(() => {
    (async () => {
      //
      let parametros = textoBuscado.replace("/", "__");
      if (parametros.length > 0) {
        const response = await fetchConToken(`Compras/Proveedores/ConsultarProveedoresPorParametros/${parametros}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (lista.length > 0) setOptions(lista);
          console.log(lista)
        }
      }
    })();
  }, [textoBuscado]);


  useEffect(() => {
    if (!isOpen) {
      setOptions([]);
    }
  }, [isOpen]);

  useEffect(() => {
    clearTimeout(typingTimer)
    // eslint-disable-next-line
  }, [])


  const handleInputChange = (e) => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setTextoBuscado(e.target.value);
    }, BUSCADOR_CENTRAL.MILISEG_SIN_CAMBIOS);
  };

  const handleSubmit = () => {
    console.log(proveedor)
    if (proveedor) dispatch({type: types.proveedorAgregarSuccess, payload: proveedor})
    else dispatch(startAlerta("Debe seleccionar un proveedor primero", "warning"))
  }
console.log(proveedor)
  return (
    <ValidatorForm onSubmit={handleSubmit}   >
      <Grid container spacing="8">
        <Grid item xs={10}>
          <Autocomplete
            fullWidth={true}
            style={{
              padding: 6,
              backgroundColor: "#FAFAFA",
              borderRadius: 5,
            }}
            options={options}
            loadingText="Buscando..."
            noOptionsText="No se ha encontrado proveedor."
            open={isOpen}
            onOpen={toggleOpen}
            onClose={toggleOpen}
            onChange={(_, val) => {
              setProveedor(val)
            }}
            onInputChange={(_, val, evt) => {
              if (val === "" || evt === "clear") {
                dispatch(desSeleccionarProveedor())
                setProveedor(null)
                setTextoBuscado("")
              }
            }}
            clearOnBlur
            loading={cargando}
            getOptionSelected={(option, value) =>
              option?.idProveedor === value?.idProveedor
            }
            getOptionLabel={(option) =>
              `${option.nombreFantasia} - CUIT ${option.cuit}`
            }
            renderOption={(option) => (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{option.nombreFantasia}</span>
                <span
                  style={{
                    fontSize: 12,
                  }}
                >
                  {" "}
                  {`CUIT: ${option.cuit}`}
                </span>
              </div>
            )}
            renderInput={(params) => (
              <TextField
                onChange={handleInputChange}
                style={{
                  padding: 3,
                }}
                {...params}
                variant="outlined"
                label="Cod. Proveedor | CUIT | Razón Social | Nombre Fantasía"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {cargando ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={12} md={9}>
          <Grid container alignContent="center" style={{ height: "100%", paddingLeft: "1rem" }}>
            <Grid item>
              {
                textoBuscado !== "" && <Typography variant="overline" color="textSecondary">Para deseleccionar borre el texto</Typography>
              }
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={12} md={2} marginTop="10px">
          <Grid container justify="center" alignItems="center" style={{ height: "100%" }} >
            <Grid item>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={hasMedic}
              >
                Seleccionar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ValidatorForm>
  );
};

